import { getRecordList } from '@src/utils/media-data';
import OptionalImage from '@src/components/optional-image';
import React, { useMemo } from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import Part2Store from './store';
import BaseSwiper from '@src/components/swiper/base-swiper';
const styles = require('./index.less');

const Part2 = () => {
  const store = useStore(() => new Part2Store());
  const featureSwiper = useMemo(
    () => {
      if (!getRecordList(store.featureData).length) {
        return null;
      } else {
        return (
          <div className={styles.featureSwiper}>
            <BaseSwiper store={store.featureSwiperStore}>
              {getRecordList(store.featureData).map((item, index) => (
                <div key={index} className={styles.featureSwiperItem}>
                  <OptionalImage src={item.img} alt={`feature-img-${index}`} className={styles.featureSwiperItemImg} />
                </div>
              ))}
            </BaseSwiper>
          </div>
        );
      }
    },
    [store.featureData, store.activeFeatureIndex]
  );
  return (
    <div className={styles.part2Root}>
      <div className={styles.part2Title} />
      {featureSwiper}
      <div id="feature-pagination" className={styles.featurePagination} />
    </div>
  );
};

export default observer(Part2);
